import * as React from "react";
import { BaseIcon, BaseIconProps, BaseSVGIconProps } from "./BaseIcon";

const SvgCustomFile = ({
  color,
  alt,
  "aria-roledescription": roleDescription = "Represents a File",
  ...restProps
}: BaseSVGIconProps) => (
  <svg
    width="28"
    height="41"
    viewBox="0 0 28 41"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <title>{alt}</title>
    {roleDescription ? <desc>{roleDescription}</desc> : null}
    <path
      d="M27.28 9.26001V37.61C27.28 38.71 26.38 39.61 25.28 39.61H2.5C1.4 39.61 0.5 38.71 0.5 37.61V2.51001C0.5 1.41001 1.4 0.51001 2.5 0.51001H18.67L27.28 9.26001Z"
      fill="white"
    />
    <path
      d="M25.28 40.1H2.5C1.12 40.1 0 38.98 0 37.6V2.5C0 1.12 1.12 0 2.5 0H18.67C18.8 0 18.93 0.0500015 19.03 0.150002L27.64 8.9C27.73 8.99 27.78 9.12 27.78 9.25V37.6C27.78 38.98 26.66 40.1 25.28 40.1ZM2.5 1C1.67 1 1 1.67 1 2.5V37.6C1 38.43 1.67 39.1 2.5 39.1H25.28C26.11 39.1 26.78 38.43 26.78 37.6V9.46L18.46 1H2.5Z"
      fill="#C4CBD0"
    />
    <path
      d="M26.57 9.59H20.5C19.4 9.59 18.5 8.69 18.5 7.59V1.5"
      fill="white"
    />
    <path
      d="M26.57 10.09H20.5C19.12 10.09 18 8.97 18 7.59V1.5C18 1.22 18.22 1 18.5 1C18.78 1 19 1.22 19 1.5V7.59C19 8.42 19.67 9.09 20.5 9.09H26.57C26.85 9.09 27.07 9.31 27.07 9.59C27.07 9.87 26.85 10.09 26.57 10.09Z"
      fill="#C4CBD0"
    />
  </svg>
);

const CustomFile = (props: BaseIconProps) => (
  <BaseIcon {...props}>
    <SvgCustomFile />
  </BaseIcon>
);

export default CustomFile;
